import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { forkJoin } from 'rxjs';
import { ProductoConfirmacionVinculacionService } from '../../../_services/producto-confirmacion-vinculacion.service';
import { ListaService } from '../../../_services/lista.service';
import { CuestionarioService } from '../../../_services/cuestionario.service';
import { ListaItem } from '../../../_models/lista-item';
import { Cuestionario } from '../../../_models/cuestionario';
import { ProductoConfirmacionVinculacion } from '../../../_models/producto-confirmacion-vinculacion';
import { Location } from '@angular/common';
import { Table } from 'primeng/table';

@Component( {
  selector: 'app-producto-confirmacion-vinculacion',
  templateUrl: 'producto-confirmacion-vinculacion.component.html'
} )

export class ProductoConfirmacionVinculacionComponent implements OnInit {

  @Input() producto: Producto;
  lisVinculacionesTodos: ListaItem[] = [];
  lisVinculaciones: SelectItem[] = [];
  lisCuestionarioTodos: Cuestionario[] = [];
  lisCuestionario: SelectItem[] = [];
  carInformacionInicial = true;
  carTabla = true;
  lisProductoConfirmacionVinculacion: ProductoConfirmacionVinculacion[] = [];
  productoConfirmacionVinculacion: ProductoConfirmacionVinculacion;
  formulario: FormGroup;
  submitted = false;
  columnas: any[];
  guardando = false;
  vinculacionesNoFirmantes = [ 'NOFIR' ];
  busqueda: string;
  @ViewChild('dt') tabla: Table;

  constructor( private serProductoConfirmacionVinculacion: ProductoConfirmacionVinculacionService,
               private serListas: ListaService,
               private serCuestionarios: CuestionarioService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private conServicio: ConfirmationService,
               private location: Location ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreTipoVinculacion', header: this.navServicio.buscarMensaje( 'PRODUCTOCONFVINC.LBL_VINCULACION' ), sort: false },
      { field: 'nombreCuestionario', header: this.navServicio.buscarMensaje( 'PRODUCTOCONFVINC.LBL_CUESTIONARIO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.busqueda = this.navServicio.getSearch( 'producto-confirmacion-vinculacion.component' );

    forkJoin( this.serListas.getMasterDetails( 'ListasTiposVinculaciones' ),
      this.serCuestionarios.listado(),
      this.serProductoConfirmacionVinculacion.listadoPorProducto( this.producto.idProducto ) ).subscribe( ( [ tipoVinculacion, cuestionarios, confirmacionVinculacion ] ) => {
      this.lisVinculacionesTodos = tipoVinculacion;
      this.lisCuestionarioTodos = cuestionarios;
      this.lisProductoConfirmacionVinculacion = confirmacionVinculacion;
      this.lisCuestionarioTodos.map( ( s: Cuestionario ) => {
        this.lisCuestionario.push( { label: s.nombre, value: s.idCuestionario } );
      } );
      this.cargarVinculaciones();
      this.cargarFormulario();
      this.carInformacionInicial = false;
      this.carTabla = false;
    } );
  }

  cargarVinculaciones() {
    this.lisVinculaciones = [];
    this.lisVinculacionesTodos.map( ( s: ListaItem ) => {
      if ( !this.lisProductoConfirmacionVinculacion.find( x => x.idTipoVinculacion === s.idLista && x.indicadorHabilitado ) && s.indicadorHabilitado && !this.vinculacionesNoFirmantes.includes( s.codigo ) ) {
        this.lisVinculaciones.push( { label: s.nombre, value: s.idLista } );
      }
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProducto: [ this.producto ? this.producto.idProducto : null, [ Validators.required ] ],
      idProductoConfirmacionVinculacion: [ this.productoConfirmacionVinculacion ? this.productoConfirmacionVinculacion.idProductoConfirmacionVinculacion : null ],
      idTipoVinculacion: [ this.productoConfirmacionVinculacion ? this.productoConfirmacionVinculacion.idTipoVinculacion : null, [ Validators.required ] ],
      idCuestionario: [ this.productoConfirmacionVinculacion ? this.productoConfirmacionVinculacion.idCuestionario : null ],
      indicadorHabilitado: [ this.productoConfirmacionVinculacion ? this.productoConfirmacionVinculacion.indicadorHabilitado : true, [ Validators.required ] ],
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.guardando = true;
    if ( this.formulario.valid ) {
      this.carInformacionInicial = true;
      this.carTabla = true;
      const formulario = this.formulario.value;
      const exiRegistro = this.lisProductoConfirmacionVinculacion.find( x => x.idTipoVinculacion === formulario.idTipoVinculacion && !x.indicadorHabilitado );
      if ( this.productoConfirmacionVinculacion && (this.productoConfirmacionVinculacion.idProductoConfirmacionVinculacion !== '' && this.productoConfirmacionVinculacion.idProductoConfirmacionVinculacion !== null && this.productoConfirmacionVinculacion.idProductoConfirmacionVinculacion !== undefined) ) {
        /** editar */
        this.serProductoConfirmacionVinculacion.actualizar( formulario ).subscribe( registro => {
          this.actualizarConfirmacionVinculacion();
        } );
      } else {
        /** crear o actualizar dependiendo de si ya existe un registro */
        if ( exiRegistro ) {
          exiRegistro.indicadorHabilitado = true;
          exiRegistro.idCuestionario = formulario.idCuestionario;
          this.serProductoConfirmacionVinculacion.actualizar( exiRegistro ).subscribe( registro => {
            this.actualizarConfirmacionVinculacion();
          } );
        } else {
          this.serProductoConfirmacionVinculacion.crear( formulario ).subscribe( registro => {
            this.actualizarConfirmacionVinculacion();
          } );
        }
      }
    } else {
      this.guardando = false;
    }
  }

  proConVinHabilitados() {
    return this.lisProductoConfirmacionVinculacion.filter( z => z.indicadorHabilitado );
  }

  actualizarConfirmacionVinculacion() {
    this.lisProductoConfirmacionVinculacion = [];
    this.serProductoConfirmacionVinculacion.listadoPorProducto( this.producto.idProducto ).subscribe( registros => {
      this.lisProductoConfirmacionVinculacion = registros;
      this.salir();
    } );
  }

  editar( registro: ProductoConfirmacionVinculacion ) {
    this.productoConfirmacionVinculacion = registro;
    this.lisVinculaciones.push( { label: registro.nombreTipoVinculacion, value: registro.idTipoVinculacion } );
    this.cargarFormulario();
  }

  salir() {
    this.productoConfirmacionVinculacion = null;
    this.cargarVinculaciones();
    this.cargarFormulario();
    this.submitted = false;
    this.guardando = false;
    this.carTabla = false;
    this.carInformacionInicial = false;
    this.navServicio.setMesage( 1 );
  }

  setBusqueda() {
    //comentario para hacer el commit
    this.navServicio.setSearch( 'producto-confirmacion-vinculacion.component', this.busqueda );
  }

  inhabilitar( registro: ProductoConfirmacionVinculacion ) {
    this.guardando = true;
    this.carTabla = true;
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'confirmacion-vinculacion',
      accept: () => {
        this.carInformacionInicial = true;
        registro.indicadorHabilitado = false;
        this.serProductoConfirmacionVinculacion.actualizar( registro ).subscribe( regActualizado => {
          this.cargarVinculaciones();
          this.actualizarConfirmacionVinculacion();
        } );
      },
      reject: () => {
        this.guardando = false;
        this.carTabla = false;
      }
    } );
  }

}
